import React from 'react';
import Modal from '@omilia/modal';

import messages from 'constants/messages';
import WarningModalContent from '../../components/WarningModalContent';

type Props = {
  loading: boolean;
  onSubmit: () => void;
  onCancel: () => void;
};

const FetchRequiredModal = ({ onSubmit, onCancel, loading }: Props) => (
  <Modal
    open
    glyph="notification-warning"
    hasBackdrop={false}
    title={messages.VERSION_CONTROL.MODAL.GIT_STATUS.ERROR_TITLE_FETCH}
    variant="danger"
  >
    <WarningModalContent
      primaryButton={{
        text: 'Fetch',
        loading,
        onClick: onSubmit,
      }}
      warningText={messages.VERSION_CONTROL.MODAL.GIT_STATUS.ERROR_BODY_FETCH}
      onCancel={onCancel}
    />
  </Modal>
);

export default FetchRequiredModal;
